/**
 * @file
 * Utils file for all Javascript.
 */
(function($, Drupal) {
    /*
     * For global debug. For specific debug: change only the debug on the
     * concerned behavior.
     */
    const DEBUG = false;

    $.extend(Drupal.theme, {
        DEBUG: DEBUG,

        BREAKPOINTS: {
            bkpWrapperDesktop: 1000,
            bkpSwitchTablet: 800,
            bkpWrapperTablet: 650,
            bkpSwitchMobile: 500,
            bkpWrapperMobile: 400,
        },

        SELECTORS: {
            $window: $(window),
            $html: $('html'),
            $body: $('body'),
        },

        COLORS: {
            BLACK: '\x1B[30m',
            RED: '\x1B[31m',
            GREEN: '\x1B[32m',
            YELLOW: '\x1B[33m',
            BLUE: '\x1B[34m',
            MAGENTA: '\x1B[35m',
            CYAN: '\x1B[36m',
            WHITE: '\x1B[37m',
            GRAY: '\x1B[90m',
        },

        /**
         * Logging function
         *
         * @param {Boolean} debug
         * @param {string} color
         * @param {string} namespace
         * @param {array} args
         */
        log(debug, color, namespace, args) {
            if (DEBUG || debug) {
                console.log(
                    color + namespace + '\x1b[0m',
                    ...args
                );
            }
        },
    });
})(jQuery, Drupal);
